const getQuestions = async (controller, callback) => {
  const action = {
    action: "customize",
    target: "questions",
  };

  controller.apiService
    .cardAction(action)
    .then((reply) => callback(reply.questions ? JSON.parse(reply.questions) : null));
};

const getElements = (controller, questionIndex, callback) => {
  const action = {
    action: "customize",
    target: "elements",
    index: questionIndex
  };

  controller.apiService
      .cardAction(action)
      .then((reply) => callback(reply.elements ? JSON.parse(reply.elements) : null));
};

const CustomizeElementsHelper = {
  getQuestions,
  getElements,
};

export default CustomizeElementsHelper;
